module.exports = __webpack_public_path__ + "img/CM.e2522767.svg";